/* eslint-disable react/prop-types */
const MainHeader = ({ children }) => (
  <header className="main-header relative flex items-center justify-between top-0 left-0 w-full h-16 px-6 sm:px-8 z-10 bg-[rgba(31,31,40,0.5)] lg:hidden">
    {children}
  </header>
);
export default MainHeader;
